import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

type ConfirmBidDialogProps = {
  handleClose: (confirmed: boolean) => void;
  open: boolean;
};

const ConfirmBidDialog = ({ handleClose, open }: ConfirmBidDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={() => handleClose(false)}>
      <DialogTitle>{t('alerts.confirmBidTitle')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('alerts.confirmBid')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose(false)} color="primary" size="small">
          {t('common.cancel')}
        </Button>
        <Button onClick={() => handleClose(true)} autoFocus variant="contained" color="primary" size="small">
          {t('common.continue')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmBidDialog;
